/**
 * Defines the FormSubmissionView component, a feedback display shown to the user after a form has been successfully submitted.
 */
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import theme from '../../styles/theme';

/**
 * A feedback component displayed after successful form submission, featuring a thank-you message and a customisable secondary message.
 * Includes a button allowing users to return to the application.
 *
 * @component
 * @param {Object} props - The properties passed to the component
 * @param {string} props.text - The text to be displayed
 * @returns {JSX.Element} A component consisting of custom successful submitition text
 */
export const FormSubmissionView = ({ text }) => {
    return (
        <Typography
            sx={{
                fontSize: '1.6rem',
                color: theme.palette.font.white,
                textAlign: 'center',
                fontWeight: 600,
                textShadow: '0px 4px 4px #00000040',
                whiteSpace: 'pre-wrap'
            }}
        >
            {text}
        </Typography>
    );
};

FormSubmissionView.propTypes = {
    text: PropTypes.string.isRequired
};
